// Copyright (c) 2022 by Move Closer

import { ModalRegistry } from '@movecloser/front-core'
import { AsyncComponent } from 'vue'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum Modals {
  PrivacyModal = 'privacyModal'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const modalsRegistry: ModalRegistry<AsyncComponent> = {
  [Modals.PrivacyModal]: () => import(/* webpackChunkName: "modal/PrivacyModal" */ '../organisms/PrivacyModal/PrivacyModal.vue')
}
